import axios from "../config/axios";
import Constants from "../data/Constants";

export const getClassList = async (filters = {}, pagination = {}) => {
  return await axios
    .get(Constants.ENDPOINTS.CLASS.ALL, {
      params: filters,
    })
    .then((res) => {
      return res.data.result;
    });
};

export const getSingleClass = async (id) => {
  return await axios.get(Constants.ENDPOINTS.CLASS.SINGLE + id).then((res) => {
    return res.data.result;
  });
};

export const getClassStudentsList = async (id) => {
  return await axios
    .get(Constants.ENDPOINTS.CLASS.STUDENTS + id)
    .then((res) => {
      return res.data.result;
    });
};

export const createSchedule = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.CLASS.SCHEDULE, data)
    .then((res) => {
      return res.data.result;
    });
};

export const transferClass = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.CLASS.TRANSFER, data)
    .then((res) => {
      return res.data.result;
    });
};

export const removeStudentFromClass = async (data) => {
  return await axios
    .post(Constants.ENDPOINTS.CLASS.REMOVE_FROM_CLASS, data)
    .then((res) => {
      return res.data.result;
    });
};

// export const updateSingleCourse = async (id, data) => {
//   return await axios
//     .patch(Constants.ENDPOINTS.COURSE.UPDATE + id, data)
//     .then((res) => {
//       return res.data.result;
//     });
// };
